import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=1b2b2260&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"
import style0 from "./Language.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports